import * as React from 'react';
import { PageSection } from '../../atoms/layout/PageSection';
import { OverlayPage } from '../../../../commonv3/components/molecules/layout/OverlayPage';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import { Route, RouteComponentProps, Switch } from 'react-router';
import EventDetailsPane from '../events/EventDetailsPane';
import { EventReservationPane } from '../events/EventReservationPane';
import { EventReservationCompletePane } from '../events/EventReservationCompletePane';
import { EventReservationErrorPane } from '../events/EventReservationErrorPane';
import { inject, observer } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import './topPane.module.scss';
import { LessonProgressCard } from '../../lessons/LessonProgressCard';
import { SessionListPane } from '../sessions/SessionListPane';
import { SessionReservationPane } from '../sessions/SessionReservationPane';
import { SessionReservationErrorPane } from '../sessions/SessionReservationErrorPane';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { PaymentListPane } from '../mypage/PaymentListPane';
import { PaymentInfoPane } from '../mypage/PaymentInfoPane';
import { PaymentRetryPane } from '../mypage/PaymentRetryPane';
import { MyPageNavigation } from '../mypage/MyPageNavigation';
import { ReservationListPane } from '../mypage/ReservationListPane';
import { EmailChangePane } from '../mypage/EmailChangePane';
import { PasswordChangePane } from '../mypage/PasswordChangePane';
import { EmptyProgressCard } from '../../lessons/EmptyProgressCard';
import { ProfileChangePane } from '../mypage/ProfileChangePane';
import { GoalsPane } from '../goals/GoalsPane';
import { MonthlyGoalPane } from '../goals/MonthlyGoalPane';
import { YearlyGoalPane } from '../goals/YearlyGoalPane';
import { IdealCareerPane } from '../goals/IdealCareerPane';
import { WelcomePane } from '../welcome/WelcomePane';
import { SheModal } from '../../../../commonv3/components/molecules/layout/SheModal';
import { NotificationPane } from './notifications/NotificationPane';
import { ReceiptInfoPane } from '../mypage/ReceiptInfoPane';
import { CoachingSessionListPane } from '../sessions/CoachingSessionListPane';
import { PlansPane2 } from '../mypage/PlansPane2';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SessionReservationCompletePane } from '../sessions/SessionReservationCompletePane';
import { SessionEvaluationPane } from '../sessions/SessionEvaluationPane';
import { HomeLocationPane } from '../mypage/HomeLocationPane';
import { HomeLocationIntroductionPage } from '../../../containers/home_locations/HomeLocationIntroductionPage';
import { HomeLocationIntroductionCompletePage } from '../../../containers/home_locations/HomeLocationIntroductionCompletePane';
import { ReservationCancelCompletePane } from '../mypage/ReservationCancelCompletePane';
import { TopPaneBanners } from './TopPaneBanners';
import { EventSection } from './events/EventSection';
import { EventArchivesSection } from './events/EventArchivesSection';
import { CoachingV2IntroductionPane } from '../sessions/CoachingV2IntroductionPane';
import { UserTutorialDetailPane } from '../user_tutorial_completions/UserTutorialDetailPane';
import { MultiCreatorSection } from './multicreatorss/MultiCreatorSection';
import { UpgradeMultiCreatorsPane } from '../mypage/UpgradeMultiCreatorsPane';
import { CareerCoachingSessionListPane } from '../sessions/CareerCoachingSessionListPane';

type Props = RouteComponentProps & {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class TopPane extends React.Component<Props> {
    needle(arr: Array<string>): string {
        return arr.find((needle) => routingStore.location.pathname.includes(needle));
    }

    render() {
        const { url } = this.props.match;
        const {
            eventList,
            workingLessons,
            notification,
            locations,
            completeIntroduction,
            loading: pageLoading,
        } = this.props.homeState;
        const primaryNotification = notification.getOrElse(null);
        const currentUser = GlobalStatesV3.currentUser;
        const loading = pageLoading || GlobalStatesV3.currentUser.homeLocation.loading;
        return (
            <div>
                <TopPaneBanners />
                <PageSection title="LEARNING COURSE" subTitle="学習中のレッスン" background="mint-green">
                    {workingLessons.loading && <LoaderRow />}
                    <div styleName="working-lessons">
                        {!workingLessons.loading && workingLessons.getOrElse([]).length === 0 && <EmptyProgressCard />}
                        {workingLessons
                            .getOrElse([])
                            .map((lesson) => (
                                <LessonProgressCard
                                    key={lesson.id}
                                    courseId={lesson.course.id}
                                    lessonId={lesson.id}
                                    progress={
                                        lesson.section_count > 0
                                            ? lesson.completed_section_count / lesson.section_count
                                            : 0
                                    }
                                    courseName={lesson.course.title}
                                    lessonIndex={lesson.index + 1}
                                    lessonName={lesson.title}
                                    lessonThumbnail={lesson.course.card_eyecatch}
                                />
                            ))}
                    </div>
                </PageSection>
                <MultiCreatorSection />
                <EventSection locations={locations} eventList={eventList} currentUser={currentUser} />
                <EventArchivesSection eventList={eventList} />
                {loading && <LoaderRow />}
                <SheModal
                    open={!!primaryNotification}
                    onRequestClose={() => this.props.homeState.closeCourseCompletionNotification()}
                >
                    <NotificationPane notification={primaryNotification} />
                </SheModal>
                <OverlayPage
                    open={
                        ['user_tutorials', 'events', 'sessions', 'mypage', 'goals'].find(
                            (needle) =>
                                // TODO: Clean up this logic and automatically detect whether sub-routes are active or not
                                routingStore.location.pathname.includes(needle) &&
                                !routingStore.location.pathname.includes('evaluation')
                        ) != null
                    }
                    onRequestClose={() => routingStore.push(V3Routes.home())}
                    id={this.needle(['events', 'sessions', 'mypage', 'goals'])}
                >
                    <Switch>
                        <Route exact path={`${url}/sessions`} component={SessionListPane} />
                        <Route exact path={`${url}/coaching_sessions`} component={CoachingSessionListPane} />
                        <Route
                            exact
                            path={`${url}/career_coaching_sessions`}
                            component={CareerCoachingSessionListPane}
                        />
                        <Route exact path={`${url}/user_tutorials/:page_key`} component={UserTutorialDetailPane} />
                        <Route
                            exact
                            path={`${url}/coaching_sessions_introduction`}
                            component={CoachingV2IntroductionPane}
                        />
                        <Route
                            exact
                            path={`${url}/sessions/:sessionId/reservation`}
                            component={SessionReservationPane}
                        />
                        <Route
                            exact
                            path={`${url}/sessions/:sessionId/reservation_complete`}
                            component={SessionReservationCompletePane}
                        />
                        <Route
                            exact
                            path={`${url}/sessions/:sessionId/reservation_error`}
                            component={SessionReservationErrorPane}
                        />
                        <Route exact path={`${url}/events/:eventId`} component={EventDetailsPane} />
                        <Route exact path={`${url}/events/:eventId/reservation`} component={EventReservationPane} />
                        <Route
                            exact
                            path={`${url}/events/:eventId/reservation_complete`}
                            component={EventReservationCompletePane}
                        />
                        <Route
                            exact
                            path={`${url}/events/:eventId/reservation_error`}
                            component={EventReservationErrorPane}
                        />
                        <Route exact path={`${url}/mypage`} component={MyPageNavigation} />
                        <Route exact path={`${url}/mypage/plans`} component={PlansPane2} />
                        <Route exact path={`${url}/mypage/multicreators`} component={UpgradeMultiCreatorsPane} />
                        <Route exact path={`${url}/mypage/payments`} component={PaymentListPane} />
                        <Route exact path={`${url}/mypage/payment_info`} component={PaymentInfoPane} />
                        <Route exact path={`${url}/mypage/home_location`} component={HomeLocationPane} />
                        <Route exact path={`${url}/mypage/retry_payment/:code`} component={PaymentRetryPane} />
                        <Route exact path={`${url}/mypage/payments/:code/receipt`} component={ReceiptInfoPane} />
                        <Route exact path={`${url}/mypage/password`} component={PasswordChangePane} />
                        <Route exact path={`${url}/mypage/email`} component={EmailChangePane} />
                        <Route exact path={`${url}/mypage/profile`} component={ProfileChangePane} />
                        <Route
                            exact
                            path={`${url}/mypage/reservations/cancel_complete`}
                            component={ReservationCancelCompletePane}
                        />
                        <Route exact path={`${url}/mypage/reservations`} component={ReservationListPane} />
                        <Route exact path={`${url}/goals`} component={GoalsPane} />
                        <Route exact path={`${url}/goals/ideal_career`} component={IdealCareerPane} />
                        <Route exact path={`${url}/goals/yearly`} component={YearlyGoalPane} />
                        <Route exact path={`${url}/goals/monthly`} component={MonthlyGoalPane} />
                    </Switch>
                </OverlayPage>
                <SheModal
                    id="welcome_introduction_modal"
                    open={
                        ['welcome', 'introduction/home_location'].find((needle) =>
                            routingStore.location.pathname.includes(needle)
                        ) != null
                    }
                    onRequestClose={completeIntroduction}
                >
                    <Switch>
                        <Route
                            exact
                            path={`${url}/welcome`}
                            render={() => <WelcomePane onComplete={completeIntroduction} />}
                        />
                        <Route
                            exact
                            path={`${url}/introduction/home_location`}
                            component={HomeLocationIntroductionPage}
                        />
                        <Route
                            exact
                            path={`${url}/introduction/home_location/complete`}
                            component={HomeLocationIntroductionCompletePage}
                        />
                    </Switch>
                </SheModal>
                {/* Empty pages */}
                <Switch>
                    <Route exact path={`${url}/sessions/:sessionId/evaluation`} component={SessionEvaluationPane} />
                </Switch>
            </div>
        );
    }
}
